import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { courseFilterAction } from 'src/reducers/course/action'
import CourseHeader from './components/header'
import CourseView from 'src/pages/collection/components/collection-page-view/components/course-view'
import { withStyles } from '@material-ui/core'
import styles from './styles'

const useDebounce = (callback, delay) => {
  const timeoutRef = useRef(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args)
    }, delay)
  }
}

const Courses = ({ classes }) => {
  const courses = useSelector(state => state.course.independentCourseList)
  const [searchTerm, setSearchTerm] = useState('')
  const [sortOption, setSortOption] = useState('created_date_desc')

  const dispatch = useDispatch()

  const fetchCourses = useCallback(
    (search = '', sort = 'created_date_desc') => {
      // Parse sort option to determine sortingColumn and direction
      let sortingColumn = ''
      let asc = false

      if (sort.includes('created_date')) {
        sortingColumn = 'createdAt'
        asc = sort === 'created_date_asc'
      } else if (sort.includes('name')) {
        sortingColumn = 'name'
        asc = sort === 'name_asc'
      }

      const data = {
        filterText: search,
        sortingColumn: sortingColumn,
        asc: asc,
        currentPage: 0,
        pageSize: 100,
        independent: true,
      }

      dispatch(courseFilterAction(data, response => {}))
    },
    [dispatch],
  )

  const debouncedFetchCourses = useDebounce(fetchCourses, 500)

  useEffect(() => {
    fetchCourses()
  }, [fetchCourses])

  const handleRefresh = (search = searchTerm, sort = sortOption) => {
    setSearchTerm(search)
    setSortOption(sort)
    if (search === '') {
      fetchCourses(search, sort)
    } else {
      debouncedFetchCourses(search, sort)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.contentWrapper}>
        <CourseHeader
          onSearch={setSearchTerm}
          onSort={setSortOption}
          onRefresh={handleRefresh}
          searchTerm={searchTerm}
          sortOption={sortOption}
        />
        <CourseView courses={courses} searchTerm={searchTerm} />
      </div>
    </div>
  )
}

export default withStyles(styles)(Courses)
